import React from 'react';

import s from './MobileListItem.module.css';

interface IProps {
  title: React.ReactNode;
  note: React.ReactNode;
  left?: React.ReactNode;
  right: React.ReactNode;
}

const MobileListItem = ({ title, note, left, right }: IProps) => (
  <div className={s.item}>
    <div className={s.leftSection}>
      {left && <div className={s.left}>{left}</div>}
      <div className={s.main}>
        <div className={s.title}>{title}</div>
        <div className={s.note}>{note}</div>
      </div>
    </div>
    <div className={s.right}>{right}</div>
  </div>
);

export { MobileListItem };
